import React from 'react';
import { ErrorBoundary } from '@grc/ui-package';
import { I18nProvider } from './stores/settings/language-context';
import { useCarrierPortalGlobalStore } from './stores/carrier-portal-global-store';
import { CarrierPortalGlobalStoreProvider } from './stores/carrier-portal-global-store';
import Layout from './pages/layout';
import AuthError from './auth0/auth-error';
import Loading from './auth0/loader';
import useAuthStartup from './auth0/useAuthStartup';
import { SettingsMenuProvider } from './contexts/settings/setting-menu-header-context';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.light.css';
import './common/styles/global.scss';
import './app.scss';

export default function App() {
  // Logs the user in (with the loop guard) and holds the layout until the token has permissions.
  const { status, errorMessage, retry, backToLogin } = useAuthStartup();
  const [selectedLanguage] = useCarrierPortalGlobalStore(
    store => store.store.selectedLanguage
  );
  //const { changeLanguage } = useDispatchActions();

  const renderContent = () => {
    if (status === 'accessDenied') {
      return (
        <AuthError errorMessage={errorMessage} onBackToLogin={backToLogin} />
      );
    }
    if (status === 'error' || status === 'redirectLoop') {
      return <AuthError errorMessage={errorMessage} onRetry={retry} />;
    }
    return status === 'authenticated' ? <Layout /> : <Loading />;
  };

  return (
    <div>
      <ErrorBoundary componentName="carrier-portal">
        <I18nProvider languageKey={selectedLanguage}>
          <CarrierPortalGlobalStoreProvider>
            <SettingsMenuProvider>{renderContent()}</SettingsMenuProvider>
          </CarrierPortalGlobalStoreProvider>
          {/* <MenuProvider>
            <SettingsMenuProvider>
              <Layout />
            </SettingsMenuProvider>
          </MenuProvider> */}
        </I18nProvider>
      </ErrorBoundary>
    </div>
  );
}
